import { format } from "date-fns";

export const formatDate = (date: number | null): string => {
	try {
		if (!date) {
			return "Data niedostępna";
		}
		return format(date, "dd.MM.yyyy");
	} catch (error) {
		console.error("Error formatting date:", error);
		return "Data niedostępna";
	}
};

export const chooseCoverDate = (
	starts_at: string | null,
	legal_status: string | null
): number => {
	if (starts_at === "NULL" || starts_at === undefined || starts_at === "") {
		return Number(legal_status);
	} else {
		return Number(starts_at);
	}
};

export const formatDuration = (minutes: number): string => {
	const hours = Math.floor(minutes / 60);
	const mins = minutes % 60;
	return `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}`;
};
